
/**
2  *  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, Input, OnInit, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { ZSDTranslateService } from '../../../../../common/zsd-translate.service';
import { DOCUMENT } from '@angular/common';

declare var $: any;

@Component({
  selector: 'zsd-formio',
  templateUrl: './zsdformio.component.html',
  styleUrls: ['./zsdformio.component.scss']
})

export class ZsdFormIOComponent implements OnInit {
  @Input('parentForm') public parentForm: FormGroup;
  @Input('formSchema') public formSchema: [];
  @Input('fromStoreItem') public fromStoreItem: boolean;
  quickCallformiForm: FormGroup;
  @Input('id') public id: number;


  constructor(public formBuilder: FormBuilder,  public zsdTranslateService: ZSDTranslateService ,  @Inject(DOCUMENT) private document) {
    if ( navigator.userAgent.indexOf('Edge') !== -1 ) {
    this.document.getElementById('formioEdge').setAttribute('href', '/servicedesk/formio/formio.full.min.css');
    }
  }

  ngOnInit() {
    this.quickCallformiForm = this.formBuilder.group({
      formioform: this.formBuilder.control({ value: null }),
      formiovalid: this.formBuilder.control( null )
    });
    if (this.parentForm) {
      this.parentForm.addControl('customform', this.quickCallformiForm);
    }
    this.parentForm.setControl('customform', this.quickCallformiForm);
  }

  onError() {
    this.quickCallformiForm.get('formiovalid').setValue(false);
  }

  onchange(event) {
    if (!event.changed) {
      return ;
    }
    this.quickCallformiForm.get('formiovalid').setValue(event.isValid);
    let data = event.data;
    this.quickCallformiForm.get('formioform').setValue(data);
  }

  onrender(data) {
    if(this.fromStoreItem){
      this.quickCallformiForm.get('formiovalid').setValue(false);
    } else {
      this.quickCallformiForm.get('formiovalid').setValue(true);
    }
    this.quickCallformiForm.get('formioform').setValue(data);
  }

  public checkSubmit() {
    $('#submit').prop('disabled', false);
    let submitButton = document.getElementsByName('data[submit]')[0];
    submitButton.click();
  }

  onSubmit() {
    this.quickCallformiForm.get('formiovalid').setValue(true);
  }
  public checkSubmitForGroup(quickCall: number[]) {
    for (let i = 0; i < quickCall.length; i++) {
      let submitButtonforQC = '#formio' + quickCall[i] + ' ' + '#submit';
      $(submitButtonforQC).prop('disabled', false);
      $(submitButtonforQC).click();
    }
}

  public getLocalizedString(key: string): string {
    return this.zsdTranslateService.getTranslatedString('ZsdFormIOComponent', key);
  }
}
